export const AUTO_PLAY_FALSE = 'home/autoPlayFalse';
export const AUTO_PLAY_TRUE = 'home/autoPlayTrue'
